export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function toLower(string) {
  return string.toLowerCase();
}

// format tel no input reference
export function formatPhoneNumber(value) {
  if (!value) return value;

  const phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;

  if (phoneNumberLength < 4) return phoneNumber;

  if (phoneNumberLength < 8) {
    return `(${phoneNumber.slice(0, 3)})${phoneNumber.slice(3)}`;
  }

  return `(${phoneNumber.slice(0, 3)})${phoneNumber.slice( 3, 7 )}-${phoneNumber.slice(7, 11)}`;
}

export function formatMobileNumber(value) {
  if (!value) return value;

  const phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;

  if (phoneNumberLength < 4) return phoneNumber
  else if (phoneNumberLength < 6) {
    return `(${phoneNumber.slice(0, 3)})${phoneNumber.slice(3)}`;
  }
  else if (phoneNumberLength < 9) {
    return `(${phoneNumber.slice(0, 3)})${phoneNumber.slice( 3, 5 )}-${phoneNumber.slice(5, 8)}`;
  }
  else
  return `(${phoneNumber.slice(0, 3)})${phoneNumber.slice( 3, 5 )}-${phoneNumber.slice(5, 8)}-${phoneNumber.slice(8, 12)}`;
}

export function formatTinNumber(value){
  if(!value){
    return value;
  }
  
  const tin = value.replace(/[^\d]/g, "");
  
  if(tin.length < 4 ) return tin; 
  else if(tin.length < 7){
    return `${tin.slice(0, 3)}-${tin.slice(3, 6)}`;
  }
  else if(tin.length<9){
    return `${tin.slice(0, 3)}-${tin.slice(3, 6)}-${tin.slice(6, 9)}`;
  }
  else{
    return `${tin.slice(0, 3)}-${tin.slice(3, 6)}-${tin.slice(6, 9)}-${tin.slice(9,14)}`;
  }
}

// nunmber format
export const numberFormat = (value, dec) =>
  new Intl.NumberFormat('en-PH', {
    style: 'decimal',
    minimumFractionDigits: dec,
    maximumFractionDigits: dec
  }).format(isNaN(value) ? 0 : value);

// format value on change - 
// auto apply comma for thousand, can accept period for decimal
export function formatValueOnChange(value, format){
    if (!value) return value;

    if(format === 'decimal'){
      const checkValue = value.replace(/[^\d.]/g, "");
      const formatValue = checkValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return formatValue;
    }else if(format === 'numeric'){
      const checkValue = value.replace(/[^\d]/g, "");
      const formatValue = checkValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return formatValue;
    }else if(format === 'numberonly'){
      const checkValue = value.replace(/[^\d]/g, "");
      return checkValue;
    }else if(format === 'decimalonly'){
      const checkValue = value.replace(/[^\d.]/g, "");
      return checkValue;
    }else if(format === 'withnegative'){
      const checkValue = value.replace(/[^\d.-]/g, "");
      const formatValue = checkValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return formatValue;
    }
};

// format tel no input reference
export function formatTIN(value) {
  if (!value) return value;

  const tin = value.replace(/[^\d]/g, "");
  const tinLength = tin.length;

  if (tinLength < 4) return tin
  else if (tinLength < 7) {
    return `${tin.slice(0, 3)}-${tin.slice(3)}`;
  }
  else if (tinLength < 10) {
    return `${tin.slice(0, 3)}-${tin.slice(3, 6)}-${tin.slice(6, 9)}`;
  }
  else
  return `${tin.slice(0, 3)}-${tin.slice( 3, 6 )}-${tin.slice(6, 9)}-${tin.slice(9, 14)}`;
}


export function makeRowID(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}